import { connect } from 'react-redux';
import { handleFilterItems } from '../../../actions/admin_actions';
import UniversityAutocomplete from '../../../components/admin/universities/UniversityAutocomplete';

const mapStateToProps = (state) => {
  return {
    adminUserSession: state.adminLogin.adminUserSession,
    adminFilterItems: state.adminFilterItems.adminFilterItems
  }
}

const UniversityFilterContainer = connect(mapStateToProps, { handleFilterItems })(UniversityAutocomplete)

export default UniversityFilterContainer;